import { Component } from '@angular/core';
import { Priority } from 'src/app/shared/constants/global.enum';
import {
  formatSingleDate,
  generateLast12Months,
} from '@app/shared/utils/utils';
import {
  AssetManagementService,
  CardType,
} from '../../asset-management-service';
import {
  UPCOMING_OFFBOARDING_COLUMNS as UPCOMING_OFFBOARDING_COLUMNS_DEF,
  UPCOMING_OFFBOARDING_TABLE_CONFIG,
} from '../../asset-management-table-configuration';
import { TableConfig } from '@app/shared/components/table/table.interfaces';
import { DateUtils } from '@utils/date.utils';
import { yearDateFormat } from '@constants/dateFormat';
import { OffboardingRequest } from '../../asset-management-table/offboarding-requests-table.service';
import { ToasterService } from '@services/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-offboarding-card',
  templateUrl: './offboarding-card.component.html',
  styleUrls: ['./offboarding-card.component.scss'],
})
export class OffboardingCardComponent {
  isLoading: boolean = false;
  priority = Priority;
  offboardingData: OffboardingRequest[] = [];
  selectedMonthLabel: string | null = null;
  selectedMonthValue: string = `${new Date().getMonth() + 1}-${new Date().getFullYear()}`;
  maxTableHeight: string = '300px';
  monthOptions = generateLast12Months();
  monthSelected: string = '';
  yearSelected: string = '';
  public readonly UPCOMING_OFFBOARDING_COLUMNS =
    UPCOMING_OFFBOARDING_COLUMNS_DEF;
  tableConfig: TableConfig = UPCOMING_OFFBOARDING_TABLE_CONFIG;
  gridOptions: any = {
    context: {
      componentParent: this,
    },
  };

  constructor(
    private assetMgmtService: AssetManagementService,
    private toasterService: ToasterService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit() {
    const currentDate = new Date();
    this.selectedMonthValue = `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    this.monthSelected = DateUtils.getMonthName(currentDate.getMonth());
    this.yearSelected = currentDate.getFullYear().toString();
    this.loadOffboardingData(
      formatSingleDate(startOfMonth, yearDateFormat.date),
      formatSingleDate(endOfMonth, yearDateFormat.date),
    );
  }

  loadOffboardingData(startDate: string, endDate: string): void {
    this.isLoading = true;
    this.assetMgmtService.getOffboardingData(startDate, endDate).subscribe({
      next: (response) => {
        this.offboardingData = response?.data;
        this.isLoading = false;
      },
      error: (error) => {
        this.toasterService.showError(
          'Failed to load offboarding data.',
          'Error',
        );
        this.isLoading = false;
      },
    });
  }

  navigateToOffboarding(): void {
    this.navigateToMyRequests('offboarding');
  }

  navigateToMyRequests(cardType: CardType = 'header'): void {
    // this.assetMgmtService.setSelectedCard(cardType);
    localStorage.setItem('selectedCard', cardType);
    this.router.navigate(['upcoming-offboarding'], {
      relativeTo: this.route,
      state: { selectedMonth: this.selectedMonthValue },
    });
  }

  onMonthSelect(event: any): void {
    this.selectedMonthLabel = event;
    if (!event) return;
    this.selectedMonthValue = event;
    // Parse month and year from the value string (M-YYYY)
    const [monthStr, yearStr] = event.split('-');
    const monthIndex = Number(monthStr) - 1;
    const year = Number(yearStr);
    const startOfMonth = new Date(year, monthIndex, 1);
    const endOfMonth = new Date(year, monthIndex + 1, 0);
    this.loadOffboardingData(
      formatSingleDate(startOfMonth, yearDateFormat.date),
      formatSingleDate(endOfMonth, yearDateFormat.date),
    );
  }
}
